import { ApiError, OpenAPI } from '@puppet/cd4pe-client-ts';
import { Cd4peError } from './errors';

const clearAuthHeaderOn401 = (error: unknown): void => {
  if (!(error instanceof Cd4peError || error instanceof ApiError)) return;
  if (error.status !== 401) return;
  if (typeof OpenAPI.HEADERS === 'object' && OpenAPI.HEADERS !== null) {
    delete (OpenAPI.HEADERS as Record<string, string>).authorization;
  }
};

export default clearAuthHeaderOn401;
